import { useSpecSchemas } from "@/lib/specSchemas";
import SpecFields from "@/components/SpecFields";
import { ListChecks } from "@phosphor-icons/react";

// Claves manejadas por otros controles del expediente (GPU, accesorios).
const HIDE = ["gpu", "includes"];
// Campos que viven en el nivel superior del expediente (compatibilidad histórica).
const BASE = { cpu: "processor", ram: "ram", storage: "storage", color: "color" };
const LEGACY_REVERSE = { battery: "battery_health", connectivity: "cellular", network: "network_lock", motherboard: "mobo", description: "gadget_description", screen: "screen_size", size: "screen_size" };

// Lee/escribe la ficha técnica del expediente: cpu/ram/storage viven en el nivel
// superior del paciente; el resto en `specs[key]` (con fallback a claves históricas).
export function patientSpecValues(form, fields) {
  const out = {};
  for (const f of fields) {
    if (BASE[f.key]) out[f.key] = form[BASE[f.key]] ?? "";
    else out[f.key] = form.specs?.[f.key] ?? form.specs?.[LEGACY_REVERSE[f.key]] ?? "";
  }
  return out;
}

export function patientSpecSummary(p, fields) {
  const vals = patientSpecValues(p, fields);
  return fields.filter((f) => f.public !== false && !HIDE.includes(f.key) && String(vals[f.key] || "").trim()).map((f) => String(vals[f.key]).trim());
}

export default function PatientSpecFields({ form, set, setSpec, equipmentType, testidPrefix = "pat-spec", showMissing = false }) {
  const { ready, schemaFor, equipmentCategory } = useSpecSchemas();
  const category = equipmentCategory(equipmentType);
  const fields = schemaFor(category);
  if (!ready) return <div className="text-xs text-zinc-400 italic col-span-2">Cargando ficha técnica…</div>;
  if (fields.length === 0) return null;
  const values = patientSpecValues(form, fields);
  const req = fields.filter((f) => f.required && !HIDE.includes(f.key));
  const done = req.filter((f) => String(values[f.key] || "").trim()).length;
  const onChange = (key, v) => (BASE[key] ? set(BASE[key], v) : setSpec(key, v));
  return (
    <div className="col-span-2" data-testid={`${testidPrefix}-section`}>
      <div className="flex items-center justify-between gap-2 mb-1.5">
        <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-semibold inline-flex items-center gap-1">
          <ListChecks size={12} weight="bold" className="text-[#002FA7]" /> Ficha técnica · {category}
        </div>
        {req.length > 0 && (
          <span className={`text-[10px] font-mono-data font-bold px-2 py-0.5 rounded-sm ${done === req.length ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`} data-testid={`${testidPrefix}-progress`}>
            {done}/{req.length} obligatorios para tienda
          </span>
        )}
      </div>
      <SpecFields fields={fields} values={values} onChange={onChange} hideKeys={HIDE} compact showMissing={showMissing} testidPrefix={testidPrefix} />
      <div className="text-[10px] text-zinc-400 mt-1">Estos campos viajan al Preinventario y a la ficha del producto en la tienda. Los marcados con * serán obligatorios antes de pasar a inventario.</div>
    </div>
  );
}
